import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { useStorage } from '@vueuse/core';
import { MyDocumentsQueries } from '../graphql/my-documents.queries';
import { MyDocumentsMutations } from '../graphql/my-documents.mutations';
import { DeviceIdHelper } from '../../helpers/device-id.helper';

const deviceId = useStorage<string>('deviceId', DeviceIdHelper.generate()).value;
export class MyDocumentsService {
  static async getToken(): Promise<string> {
    const {
      data: {
        myDocumentsToken: { token },
      },
    } = await apolloClientInternal.query({
      query: MyDocumentsQueries.token,
      variables: { deviceId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return token;
  }

  static async createEmailVerification(): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: MyDocumentsMutations.create,
      variables: { deviceId },
    });
    return data;
  }

  static async verifyEmail(code: number): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: MyDocumentsMutations.verify,
      variables: { code, deviceId },
    });
    return data;
  }
}
